import { I18n } from '@calendly/i18n'
import { FullStoryExclude } from '@calendly/ui/components/fullstory-privacy'
import { BodyText } from '@calendly/ui/components/typography'
import { useState } from 'react'

import {
  Header,
  GrowableSearchSection,
  ChatSuggestions,
  SUGGESTED_PROMPTS,
  COMPOSER_LOCATION,
  QUERY_SOURCE_TYPE
} from 'components/agent_hub_components'

import styles from './AISearchPage.module.css'


export const AISearchPage = ({
  handleSearch = () => {},
  analyticsHandlers = {},
  embedded = false,
}) => {
  const [searchQuery, setSearchQuery] = useState('')

  const handlePromptClick = (prompt) => {
    if (analyticsHandlers.trackSearchSubmitted) {
      analyticsHandlers.trackSearchSubmitted(COMPOSER_LOCATION.HOME_PAGE, QUERY_SOURCE_TYPE.SUGGESTION)
    }
    handleSearch(prompt, QUERY_SOURCE_TYPE.SUGGESTION)
  }

  const handleSearchWithAnalytics = (query) => {
    if (analyticsHandlers.trackSearchSubmitted) {
      analyticsHandlers.trackSearchSubmitted(COMPOSER_LOCATION.HOME_PAGE, QUERY_SOURCE_TYPE.TEXT)
    }
    handleSearch(query, QUERY_SOURCE_TYPE.TEXT)
  }

  return (
    <div className={styles.container}>
      <div className={styles.mainContent}>
        {!embedded && (
          <Header title={I18n.t('publisher.agent_hub.header.title')} subtitle={I18n.t('publisher.agent_hub.header.subtitle')} />
        )}

        <FullStoryExclude>
          <GrowableSearchSection
            searchQuery={searchQuery}
            onSearchChange={setSearchQuery}
            onSearch={handleSearchWithAnalytics}
            location={COMPOSER_LOCATION.HOME_PAGE}
            includeWhiteFade={false}
            analyticsHandlers={analyticsHandlers}
          />
        </FullStoryExclude>

        <div className={styles.chatSuggestionsContainer}>
          <BodyText weight="bold" color="muted">
            {I18n.t('publisher.agent_hub.suggest_prompts_heading')}
          </BodyText>
          <ChatSuggestions chatSuggestions={SUGGESTED_PROMPTS} onSuggestionClick={handlePromptClick} />
        </div>
      </div>
    </div>
  )
}
